import React from 'react'
import styled from '@emotion/styled'
import Modal from './Modal'
import Button from './Button'
import { SectionHeader, Text } from '../../../../styles/Components'
import { gsColors } from '../../../../styles/Variables'
import { mq } from '../../../../helpers'
import { DEFAULT_VALET_POLICY } from './policyCopy'

const WarningDiv = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  text-align: center;

  button {
    background-color: ${gsColors.sunsetOrange};

    ${mq('min', '600px')} {
      width: max-content;
      padding: 0 2rem;
      margin: 1rem;
    }

  }
`

const ValetWarningModal = ({
  isOpen,
  close,
  isDesktop,
  nextStep,
  title,
  explanation,
  dispatch
}) => {

  const acceptAndContinue = () => {
    dispatch('step', nextStep)
    close()
    window.scrollTo(0, 0)
  }

  return (
    <Modal
      isOpen={isOpen}
      closeModal={close}
      width="500px"
      isDesktop={isDesktop}
    >
      <WarningDiv>
        <SectionHeader>
          {title || `OUR VALET POLICY`}
        </SectionHeader>
        <Text
          margin="1rem 2rem"
        >
          {explanation || DEFAULT_VALET_POLICY}
        </Text>
        <Button
          onClick={acceptAndContinue}
        // color={gsColors.sunsetOrange}
        // margin="0 0 1rem 0"
        >
          {'Accept & Continue'}
        </Button>
      </WarningDiv>
    </Modal>
  )
}

export default ValetWarningModal
